import React from "react";
import { Link } from "react-router-dom";
import { Search, Wrench } from "lucide-react";
import { getSiteMode } from "../utils/siteMode";

const ClassicCloudIcon = ({ size, strokeWidth, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M17.5 19H6.5a4.5 4.5 0 0 1-.5-8.97A6 6 0 0 1 17 6.5a4 4 0 0 1 .5 12.5Z" />
  </svg>
);

const ClusterMergeIcon = ({ size, strokeWidth, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="5" cy="5" r="2" />
    <circle cx="5" cy="19" r="2" />
    <circle cx="5" cy="12" r="2" />
    <circle cx="20" cy="12" r="2" />
    <path d="M7 5L18 12" />
    <path d="M7 19L18 12" />
    <path d="M7 12h11" />
  </svg>
);

const FEATURES = [
  {
    icon: ClassicCloudIcon,
    title: "Cloud Basecalling",
    description:
      "Run standard DNA and XNA/modified basecalling in the cloud, without managing local GPU hardware.",
    route: "/product/basecalling",
  },
  {
    icon: ClusterMergeIcon,
    title: "Clustering",
    description:
      "Group reads into meaningful clusters and surface consensus patterns with scalable cloud workflows.",
    route: "/product/clustering",
  },
  {
    icon: Search,
    title: "Modification Discovery",
    description:
      "Detect and prioritize base modifications through integrated discovery pipelines and downstream review tools.",
    route: "/product/modification-discovery",
  },
  {
    icon: Wrench,
    title: "Supplemental Tools",
    description:
      "Extend core analysis with sharing, collaboration, quality control, and result visualization utilities.",
    route: "/product/tools",
  },
];

const FeatureGrid = () => {
  const mode = getSiteMode();

  return (
    <section id="platform" className="features-section">
      <div className="container">
        <div className="features-header">
          <h2 className="features-title">
            Core capabilities built for cloud nanopore analysis
          </h2>
          <p className="features-subtitle">
            Replace local hardware-heavy workflows with a connected cloud
            platform that scales from standard users to advanced XNA teams.
          </p>
        </div>

        <div className="features-grid">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return (
              <div key={i} className="feature-card">
                <Icon className="feature-card-icon" size={44} strokeWidth={1.5} />
                <h3 className="feature-card-title">{f.title}</h3>
                <p className="feature-card-desc">{f.description}</p>
                {mode === "dev" && (
                  <Link to={f.route} className="read-more-link">
                    Read more
                  </Link>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeatureGrid;
